<template>
  <div class="card">
    <el-card>
      <div class="ard">
        <el-radio-group v-model="produceStatus" @change="handleDateChange">
          <el-radio-button label="全部" value="0" />
          <el-radio-button label="计划确认" value="2" />
          <el-radio-button label="下达" value="3" />
          <el-radio-button label="开工" value="4" />
          <el-radio-button label="完工" value="5" />
        </el-radio-group>
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="排产时间"
          end-placeholder="结束时间"
          :shortcuts="dateShortcuts"
          @change="handleDateChange"
        />
        <div class="asd">
          <el-input
            v-model="searchBillNo"
            placeholder="请输入生产编码"
          ></el-input>
        </div>
        <div class="asd">
          <el-input
            v-model="searchMaterialNumber"
            placeholder="请输入物料编码(SKU)"
          ></el-input>
        </div>
        <el-button type="primary" @click="getProduceTasks">查询</el-button>
      </div>
    </el-card>
    <el-card class="box-card">
      <div ref="gantt_here"
           id ="gantt_here"
        style="margin-top: 10px"
        class="gantt-container"
      ></div>
    </el-card>
    <div v-if="showTooltip"
         class="custom-tooltip"
         :style="{left: tooltipPos.x + 'px', top: tooltipPos.y + 'px'}">
       {{ currentTask.progress }}

    </div>
  </div>
</template>

<script setup>
import {
  reactive,
  toRefs,
  ref,
  onMounted,
  watchEffect,
  defineExpose,
} from "vue";
import {ElButton,ElInput,ElDatePicker,ElCard,} from "element-plus";
import { gantt } from "dhtmlx-gantt";
import "dhtmlx-gantt/codebase/dhtmlxgantt.css";
import {getProduce} from "@/utils/api";
import dayjs from "dayjs";
const data = reactive({});
const tableData = ref([]);

const getMonthRange = () => {
  const end = new Date();
  const start = new Date();
  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 2);
  end.setTime(end.getTime() + 3600 * 1000 * 24 * 30 * 1);
  return [start, end];
};

// 查询参数
const currentPage = ref(1);
const total = ref(0);
const pageSize = ref(1000);
const searchMaterialNumber = ref("");
const searchBillNo = ref("");
const produceStatus = ref("0");
const dateRange = ref(getMonthRange());
let  currentTask = ref("");
let  showTooltip = ref(false);
let  tooltipPos = ref({ x: 0, y: 0 });

const dateShortcuts = [
  {
    text: "最近一周",
    value: () => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      return [start, end];
    },
  },
  {
    text: "最近一个月",
    value: () => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      return [start, end];
    },
  },
  {
    text: "最近三个月",
    value: () => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 3);
      return [start, end];
    },
  },
];

// 转换后端数据为甘特图格式
const convertToGanttData = (data) => {
  if (!data || !data.length) return { data: [], links: [] };

  return {
    data: data.map((item) => ({
      id: item.id,
      text: item.text,
      number: item.number,
      name: item.name,
      produce_qty: item.produce_qty,
      order_qty: item.order_qty,
      start_date: item.start_date,
      end_date: item.end_date,
      summary: item.summary,
      duration: item.duration || 0,
      progress: item.progress ? item.progress / 100 : 0,
    })),
    links: [],
  };
};

const getProduceTasks = async () => {

    let start_date = dayjs(dateRange.value[0]).format("YYYY-MM-DD");
    let end_date = dayjs(dateRange.value[1]).format("YYYY-MM-DD");
    let params = {
      MaterialNumber: searchMaterialNumber.value,
      BillNo: searchBillNo.value,
      PageNumber: currentPage.value,
      PageSize: pageSize.value,
      Status: produceStatus.value,
      StartDate: start_date,
      EndDate: end_date,
    };
    await getProduce(params).then(res=>{
      if (res.Code === 0) {
        total.value = res.Total;
        tableData.value = res.Data;
        // 更新甘特图数据
        const ganttData = convertToGanttData(res.Data);
        gantt.clearAll();
        gantt.parse(ganttData);
      }
    }).catch(err=>{
      console.log("获取生产任务数据失败",err)
    })


};

//初始化甘特图
const initGantt = () => {
  gantt.config.tooltip_timeout = 0;
  gantt.config.grid_width = 350;
  gantt.config.add_column = false; //添加符号
  gantt.config.autosize = false; //自适应尺寸
  gantt.config.autofit = true; // 表格列宽自适应
  gantt.config.autoscroll = true; // 把任务或者连线拖拽到浏览器屏幕外时，自动触发滚动效果
  gantt.config.drag_progress = false; //取消任务进度条进度拖动
  gantt.config.scale_height = 60;
  gantt.config.row_height = 60;
  gantt.config.bar_height = 34;
  gantt.config.readonly = false;

  gantt.config.fit_tasks = true; //自动延长时间刻度，以适应所有显示的任务
  gantt.i18n.setLocale("cn"); //设置语言
  //时间栏配置
  gantt.config.scales = [
    { unit: "month", step: 1, format: "%Y年%m月" },
    { unit: "day", step: 1, format: "%m/%d" },
  ];
  gantt.config.columns = [
    { name: "text", label: "工单编号", width: 100, align: "center" },
    { name: "number", label: "物料编码", width: 120, align: "center" },
    { name: "name", label: "物料名称", width: 120, align: "center" },
    { name: "summary", label: "生产备注", width: 150, align: "center",
      template: (task) => `
            <div title="${task.summary}">
              ${task.summary}
            </div>
          `},
    { name: "produce_qty", label: "生产数量", width: 60, align: "center" },
    { name: "order_qty", label: "订单数量", width: 60, align: "center" },
    { name: "start_date", label: "排产开始", width: 80, align: "center" },
    { name: "end_date", label: "排产结束", width: 80, align: "center" },
  ];

  gantt.init("gantt_here");
};

const handleDateChange = (val) => {
  if (!val) return;
  // 这里添加获取数据的逻辑
  getProduceTasks();
};

onMounted(() => {
  // 获取数据
  initGantt();
  getProduceTasks();
});
watchEffect(() => {});

defineExpose({
  ...toRefs(data),
});
</script>
<style scoped lang="scss">
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}

.renwus {
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  overflow: auto;
}

.renwu {
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
}

:deep(.el-progress-circle) {
  width: 100px !important;
  height: 80px !important;
}

.ps {
  padding: 0;
  margin: 0;
}

.percentage-value {
  display: block;
  margin-top: 10px;
  font-size: 28px;
}

.percentage-label {
  display: block;
  margin-top: 10px;
  font-size: 12px;
}

.demo-progress .el-progress--line {
  margin-bottom: 15px;
  width: 350px;
}

.demo-progress .el-progress--circle {
  margin-right: 15px;
}
#gantt_here {
  height: 700px; /* 设置你希望的高度 */
  overflow-y: auto; /* 启用垂直滚动条 */
}
.cardtop {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .margins {
    display: flex;
    font-size: 12px;

    p {
      margin-left: 10px;

      :deep(.el-color-picker .el-color-picker__icon) {
        opacity: 0;
      }

      :deep(.el-color-picker__trigger) {
        border: none;
        width: 25px;
        height: 25px;
      }
    }
  }
}
.gantt_custom_tooltip {
  max-width: 400px !important;
  padding: 12px !important;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  font-family: 'Segoe UI', sans-serif;
  line-height: 1.5;
}

.box-card {
  margin-top: 20px;
}

.card {
  width: 1500px;
  margin: 0 auto;

  .ard {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
  }

  .icons {
    width: 80px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #a0cfff;
    color: #46a2ff;
    margin-right: 10px;
    border-radius: 7px;
    background-color: #ecf5ff;

    i {
      color: #1890ff;
      font-size: 14px;
      margin-right: 5px;
    }
  }
  .gantt_hor_scroll {
    height: 0;
    background-color: transparent;
    width: 100%;
    clear: both;
    overflow-x: scroll;
    overflow-y: hidden;
    display: none !important;
  }
}
.asd {
  width: 300px;
  height: 33px;
  border-radius: 5px;
  border: 1px dotted #ccc;
  margin-left: 20px;
  display: flex;
  align-items: center;

  p {
    color: #606266;
    margin-left: 5px;
  }

  :deep(.el-input__wrapper) {
    border: none;
    box-shadow: none !important;
  }

  :deep(.el-date-editor.el-input) {
    width: 200px !important;
  }

  :deep(.el-select__wrapper) {
    border: none;
    box-shadow: none !important;
  }
}

:deep(.gantt_layout_cell) {
  border-radius: 7px;
}

:deep(.gantt_tree_indent) {
  opacity: 0;
}

:deep(.gantt_grid_scale .gantt_grid_head_cell) {
  color: #606266;
  font-size: 15px;
  font-weight: 700;
  border-right: 1px solid #ccc !important;
}

:deep(.gantt_scale_cell) {
  color: #454545 !important;
}

:deep(.gantt_grid_data .gantt_cell) {
  border-right: 1px solid #ccc !important;
  padding: 0;
}

:deep(.gantt_task_progress_wrapper) {
  border-radius: 5px;
  .gantt_layout_cell{
    position: relative;
  }
}

:deep(.gantt_task_line.gantt_project) {
  border-radius: 5px;
  border: none;
}

:deep(.gantt_data_area div) {
  border-radius: 5px;
  // border:none;
}

:deep(.gantt_tree_content) {
  display: flex;
  align-items: center;

  .jindu {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #4482e3;
    border-radius: 10px;
  }

  .tasktype {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

:deep(.gantt_task_line) {
  border: none;
}

:deep(.gantt_link_point) {
  display: none !important;
}

:deep(.gantt_task_progress) {
  height: 100%;
}

.toppingTask {
  width: 200px;
  height: 200px;
  background-color: #1890ff;
}
</style>
